
import { Component, Prop, Vue } from "vue-property-decorator";
import Restaurant from "@/domain/restaurant/Restaurant";
import RemoteServices from "@/services/RemoteServices";
import TimeService from "@/services/TimeService";
import { VuetifyForm } from "@/plugins/vuetify";
import PhoneInput from "@/components/PhoneInput.vue";
import FormService from "@/services/FormService";
@Component({
  components: { PhoneInput }
})
export default class RestaurantPropertiesForm extends Vue {
  @Prop({ default: false })
  createNewRestaurant!: boolean;

  @Prop({
    default: function() {
      return new Restaurant();
    }
  })
  targetRestaurant!: Restaurant;

  restaurantCopy = Restaurant.copy(this.targetRestaurant);

  requiredString = [(v: string) => !!v || "Required"];
  positive = [
    (v: number) => !!v || "Required",
    (v: number) => v > 0 || "Must be Positive"
  ];

  restaurantCreationFormValid = false;
  canEdit = false;

  closedDaysOfWeekDisplayNames = TimeService.weekDays;

  closedDaysOfWeekSelected = [];

  emailRule = [FormService.emailFormatRule];

  resetFields() {
    this.canEdit = false;
    this.restaurantCopy = Restaurant.copy(this.targetRestaurant);
    this.restaurantCreationForm.resetValidation();
  }

  get timezoneList() {
    return TimeService.getTimeZoneList();
  }

  get allowEdit() {
    return this.canEdit;
  }

  set allowEdit(newVal: boolean) {
    if (this.canEdit) {
      Restaurant.updateRestaurant(this.restaurantCopy, this.targetRestaurant);
    }
    this.canEdit = newVal;
  }

  get editRestaurant() {
    return !this.createNewRestaurant;
  }

  get restaurantHasChanges() {
    return Restaurant.haveDifferences(
      this.targetRestaurant,
      this.restaurantCopy
    );
  }

  get restaurantCreationForm() {
    return this.$refs.restaurantCreate as VuetifyForm;
  }

  /* Creating / Editing a Restaurant */
  async createRestaurant() {
    this.restaurantCreationForm.validate();
    if (this.restaurantCreationFormValid) {
      this.$store.dispatch("loading");
      try {
        this.restaurantCopy = await RemoteServices.createRestaurant(
          this.restaurantCopy
        );
        // send event up to add
        this.addNewRestaurant(this.restaurantCopy);
        await this.$store.dispatch(
          "success",
          this.$t("restaurant.create.success")
        );
        await this.$store.dispatch("selectedRestaurant", this.restaurantCopy);
        this.restaurantCopy = new Restaurant();
        this.closeDialog();
      } catch (error) {
        await this.$store.dispatch("error", error.message);
      }
      this.$store.dispatch("clearLoading");
    }
  }

  async submitChanges() {
    this.restaurantCreationForm.validate();
    if (this.restaurantCreationFormValid) {
      this.$store.dispatch("loading");
      try {
        this.restaurantCopy = await RemoteServices.editRestaurant(
          Restaurant.getLightweightCopyToSend(
            this.targetRestaurant,
            this.restaurantCopy
          )
        );
        this.updateTargetRestaurant();
        this.$store.dispatch("success", this.$t("restaurant.update.success"));
      } catch (error) {
        await this.$store.dispatch("error", error.message);
      }
      this.allowEdit = false;
      this.$store.dispatch("clearLoading");
    }
  }

  updateTargetRestaurant() {
    Restaurant.updateRestaurant(this.targetRestaurant, this.restaurantCopy);
  }

  addNewRestaurant(restaurant: Restaurant) {
    this.$store.dispatch("addRestaurant", restaurant);
    // this.$emit("new-restaurant", restaurant);
  }

  closeDialog() {
    this.$emit("input", false);
  }
}
